import React from 'react'
import PropTypes from 'prop-types'

import Drawer from '@mui/material/Drawer'
import { makeStyles } from '@mui/styles'

const EconomicAssetDrawer = (props) => {
  const classes = useStyles(props)
  const {
    open,
    onClose,
    children,
    enableBackdropClick,
  } = props
  return (
    <Drawer
      classes={{ paper: classes.drawer }}
      anchor="right"
      transitionDuration={400}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' || enableBackdropClick) {
          onClose && onClose()
        }
      }}
      ModalProps={{
        disableEscapeKeyDown: true,
      }}>
      {children}
    </Drawer>
  )
}

EconomicAssetDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  enableBackdropClick: PropTypes.bool,
}

EconomicAssetDrawer.defaultProps = {
  enableBackdropClick: false,
}

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 'auto',
    minWidth: '350px',
  },
}))

export default EconomicAssetDrawer
